import { validateSkipInput } from "@cloudnest/stone-flicking-core-engine/validators";
import type { SkipFlickAction } from "../types/actions";
import type { ValidationResult } from "../types/common";
import type { StoneFlickingState } from "../types/game-state";
import { toParticipantId } from "../utils/state-mapper";

export function validateSkipFlick(
  state: StoneFlickingState,
  action: SkipFlickAction,
): ValidationResult {
  return validateSkipInput(state.coreState, {
    type: "SKIP_INPUT",
    participantId: toParticipantId(action.playerId),
  });
}
